// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/clase-flights/list',
    name: 'clase-flights-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/flights/ClasesFlights.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'class_flight',
    },
  },
]

export default formTable
